import SlipCard from './SlipCard';
function App()
{
     return (
            <>
                <SlipCard />
            </>
        );
}

export default App;